import React from "react";
import { CalendarOff, Info } from "lucide-react";

/** Reusable holiday/info banner for absensi pages. */
export default function HolidayNotice({ holidayName, message, variant = "warning" }) {
  const palette = variant === "warning"
    ? "bg-amber-50 border-amber-200 text-amber-900"
    : "bg-sky-50 border-sky-200 text-sky-900";
  const iconColor = variant === "warning" ? "text-amber-600" : "text-sky-600";
  const Icon = variant === "warning" ? CalendarOff : Info;
  return (
    <div
      data-testid="holiday-notice"
      className={`flex items-start gap-3 rounded-xl border p-4 ${palette}`}
    >
      <Icon className={`h-5 w-5 shrink-0 mt-0.5 ${iconColor}`} />
      <div className="flex-1">
        {holidayName && (
          <div className="font-heading font-semibold text-base">
            Hari Libur — {holidayName}
          </div>
        )}
        <div className="text-sm leading-snug mt-0.5">{message}</div>
      </div>
    </div>
  );
}
